import { literals } from "@/constants/literals";
import InputSelect from "@/components/input-select/InputSelect";
import InputText from "@/components/input-text/InputText";
import {
  EMBALAJE_OPTIONS,
  VISIBLE_CLIENTE_OPTIONS,
} from "@/constants/selectsLists";
import InputCalendar from "@/components/input-calendar/InputCalendar";
import type { PhotosFilters } from "@/types/types.d";

type AdvancedPhotosSearcherProps = {
  filters: PhotosFilters;
  hasInvalidDateRange: boolean;
  changeFilterCriteria: (value: string | undefined | null, key: string) => void;
};

const AdvancedPhotosSearcher = ({
  filters,
  hasInvalidDateRange,
  changeFilterCriteria,
}: AdvancedPhotosSearcherProps) => {
  return (
    <>
      <div className="md:col-span-1">
        <InputCalendar
          name="photos-date-from"
          label={literals.dateFrom}
          value={filters.fechaDesde ?? null}
          onChange={(value) => changeFilterCriteria(value, "fechaDesde")}
          size="medium"
          helpText={literals.twoOrNoDate}
          error={hasInvalidDateRange}
          errorMessage={literals.errorDateRange}
          warning={!!filters.fechaHasta && !filters.fechaDesde}
          warningMessage={literals.needFromDate}
          lettersFormat
        />
      </div>
      <div className="md:col-span-1">
        <InputCalendar
          name="photos-date-to"
          label={literals.dateTo}
          value={filters.fechaHasta ?? null}
          onChange={(value) => changeFilterCriteria(value, "fechaHasta")}
          size="medium"
          helpText={literals.twoOrNoDate}
          error={hasInvalidDateRange}
          errorMessage={literals.errorDateRange}
          warning={!!filters.fechaDesde && !filters.fechaHasta}
          warningMessage={literals.needEndDate}
          lettersFormat
        />
      </div>
      <div className="md:col-span-3">
        <InputText
          label={literals.description}
          placeholder={literals.description}
          value={filters.description ?? ""}
          size="small"
          onChange={(value) => changeFilterCriteria(value, "description")}
          noBottomSpace
        />
      </div>
      <div className="md:col-span-1">
        <InputSelect
          size="small"
          label={literals.visibleClient}
          id="photos-visible-cliente-1"
          name="photos-visible-cliente-1"
          options={VISIBLE_CLIENTE_OPTIONS}
          value={filters.visible}
          onChange={(value) => changeFilterCriteria(value, "visible")}
          placeholder={literals.visibleClient}
        />
      </div>
      <div className="md:col-span-1">
        <InputSelect
          size="small"
          label={literals.ownPackaging}
          id="photos-embalaje-propio"
          name="photos-embalaje-propio"
          options={EMBALAJE_OPTIONS}
          value={filters.ownPackaging}
          onChange={(value) => changeFilterCriteria(value, "ownPackaging")}
          placeholder={literals.packaging}
        />
      </div>
      <div className="md:col-span-1">
        <InputSelect
          size="small"
          label={literals.correctPackaging}
          id="photos-embalaje-correcto"
          name="photos-embalaje-correcto"
          options={EMBALAJE_OPTIONS}
          value={filters.correctPackaging}
          onChange={(value) => changeFilterCriteria(value, "correctPackaging")}
          placeholder={literals.packaging}
        />
      </div>
      <div className="md:col-span-1">
        <InputSelect
          size="small"
          label={literals.damagedPackaging}
          id="photos-embalaje-danado"
          name="photos-embalaje-danado"
          options={EMBALAJE_OPTIONS}
          value={filters.damagedPackaging}
          onChange={(value) => changeFilterCriteria(value, "damagedPackaging")}
          placeholder={literals.packaging}
        />
      </div>
      <div className="md:col-span-1">
        <InputText
          label={literals.packagingReference}
          placeholder={literals.packagingReference}
          value={filters.packagingReference ?? ""}
          size="small"
          onChange={(value) =>
            changeFilterCriteria(value, "packagingReference")
          }
          noBottomSpace
        />
      </div>
      {filters.area === literals.exits && (
        <>
          <div className="md:col-span-1">
            <InputSelect
              size="small"
              label={literals.ownPackagingOut}
              id="photos-embalaje-out"
              name="photos-embalaje-out"
              options={EMBALAJE_OPTIONS}
              value={filters.ownPackagingOut}
              onChange={(value) =>
                changeFilterCriteria(value, "ownPackagingOut")
              }
              placeholder={literals.packaging}
            />
          </div>
          <div className="md:col-span-1">
            <InputSelect
              size="small"
              label={literals.iberiaPackaging}
              id="photos-embalaje-iberia"
              name="photos-embalaje-iberia"
              options={EMBALAJE_OPTIONS}
              value={filters.iberiaPackagingOut}
              onChange={(value) =>
                changeFilterCriteria(value, "iberiaPackagingOut")
              }
              placeholder={literals.packaging}
            />
          </div>
        </>
      )}
    </>
  );
};

export default AdvancedPhotosSearcher;
